import React, { Component } from 'react';

class Employee extends Component {
  render() {
    const { name, age, department, designation, salary, location } = this.props.data;

    // Initials for avatar
    const initials = name.split(" ").map(n => n[0]).join("").toUpperCase();

    // Department colors
    const deptColors = {
      IT: "bg-info",
      HR: "bg-success",
      Finance: "bg-warning",
      Marketing: "bg-danger"
    };

    return (
      <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
        <div className="card h-100 border-0 shadow employee-card">
          
          {/* Department Color Strip */}
          <div className={`card-header ${deptColors[department] || "bg-secondary"} text-white text-center fw-bold`}>
            {department}
          </div>
          
          <div className="card-body text-center">
            
            {/* Avatar */}
            <div className="avatar bg-primary text-white rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                 style={{ width: "80px", height: "80px", fontSize: "24px", fontWeight: "bold" }}>
              {initials}
            </div>

            {/* Name */}
            <h5 className="card-title fw-bold text-dark">{name}</h5>
            <p className="text-muted mb-2">{designation}</p>

            {/* Info */}
            <ul className="list-unstyled text-start small">
              <li><i className="bi bi-person-fill me-2 text-primary"></i><strong>Age:</strong> {age}</li>
              <li><i className="bi bi-cash-coin me-2 text-success"></i><strong>Salary:</strong> ₹{salary.toLocaleString()}</li>
              <li><i className="bi bi-geo-alt-fill me-2 text-danger"></i><strong>Location:</strong> {location}</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Employee;
